<template>
  <v-ons-page modifier="white" @init="initChartHisto()">

    <v-ons-toolbar class="toolbar--noshadow toolbar--noborder" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Historique - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <div class="content">

      <section class="content--perfcours" style="height: 191px">

        <span>
          {{ histo.label }}
        </span>

        <div v-if="chartIndex == -1" class="content--perfcours__infos">
          <h2>
            {{ prixCours.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
            <small>€/t</small>
          </h2>
          <span>
            {{ negoceInfos.date }}
          </span>
        </div>
        <div v-else class="content--perfcours__data">
          <span>{{ formatDate(chartData[chartIndex].x) }}</span>
          <h2>
            {{ chartData[chartIndex].y.toLocaleString('fr', { minimumFractionDigits: 2 }) }}
            <small>€/t</small>
          </h2>
        </div>

      </section>

      <canvas id="coursChart" width="375" height="375"></canvas>

      <!-- v-show="rangeStart < 4" -->
      <v-ons-segment modifier="perfarmer" :index.sync="rangeIndex" style="width: 100%">
        <button v-for="(infos, index) in rangeInfos" :disabled="index < rangeStart" :key="index">
          {{ infos.label }}
        </button>
      </v-ons-segment>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';
import mixinsGraph from '../mixins/graph.js';

import { store } from '../store.js';

export default {
  mixins: [mixinsCommons, mixinsCours, mixinsGraph],
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      refCulture: '',
      refDestination: '',
      prixId: '',
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    histo() {
      if(this.negoceId
      && this.data.histo.list[this.negoceId]
      && this.data.histo.list[this.negoceId][this.campagne]
      && this.data.histo.list[this.negoceId][this.campagne][this.refCulture]
      && this.data.histo.list[this.negoceId][this.campagne][this.refCulture][this.refDestination]){
        return this.data.histo.list[this.negoceId][this.campagne][this.refCulture][this.refDestination][this.prixId];
      }
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    prixCours() {
      var list = this.getListPrix(this.negoceInfos, this.refCulture, this.refDestination);
      for (let i = 0; i < list.length; i++) {
        const prixItem = list[i];
        if(prixItem.id == this.prixId){
          return prixItem.cours;
        }
      }
    },
    alerte() {
      if(this.strategie.negoce){
        if(this.strategie.negoce[this.negoceId] && this.strategie.negoce[this.negoceId].includes(this.prixId)){
          // exclude by AlertePrix
        } else {
          return this.strategie.objectif;
        }
      }
      return '';
    }
  },
  watch: {
    rangeIndex() {
      this.initChartHisto();
    },
  },
  methods: {
    initChartHisto() {
      this.initChart(this.histo.cours, this.alerte);
    }
  },
  created() {
    this.setRange(this.histo.cours);
  }
}
</script>
